import { createStyles, makeStyles } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { AlertStatusCard } from "../../../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";


interface ICollectionAlertProps {
    isDisabled: boolean;
    label: string;
}

const useStyles = makeStyles(() => createStyles({
    root: {
        paddingTop: "0.1rem",
        paddingBottom: "1rem"
    }
}))


export function CollectionAlert({
    isDisabled,
    label
}: ICollectionAlertProps) {
    const { root } = useStyles();
    const { t } = useTranslation();
    return isDisabled ? <div className={root}>
        <AlertStatusCard
            alertMessage={t(`forms.orders.pickup.errors.${label}`)}
            alertProps={{ severity: "error" }}
        />
    </div> : null;
}